import { useQuery } from '@apollo/client';

import { CompanyUserKycStatus, Role } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { LegalBeneficiariesDocument } from './legalBeneficiaries.gql';

export const useQuickInvitations = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error("'companyProfileId' is undefined in 'useQuickInvitations'");
  }

  const { data, ...hook } = useQuery(LegalBeneficiariesDocument, {
    variables: { companyProfileId },
  });

  const legalBeneficiaries = data?.companyLegalBeneficiaries || [];
  const quickInvitations = legalBeneficiaries
    // we don't want to invite account holder or already invited BEs
    .filter(({ companyUser }) => {
      const isInvitee = companyUser?.roles.includes(Role.Invitee);
      const isKycCompleted =
        companyUser?.kycStatus === CompanyUserKycStatus.Validated;

      return isInvitee && isKycCompleted;
    })
    .map(({ companyUser }) => ({
      ...companyUser,
    }));

  return { ...hook, quickInvitations };
};

export type QuickInvitations = NonNullable<
  ReturnType<typeof useQuickInvitations>['quickInvitations']
>;

export type QuickInvitation = QuickInvitations[number];

export function refetchQuickInvitationsQuery(companyProfileId: string) {
  return {
    query: LegalBeneficiariesDocument,
    variables: { companyProfileId },
  };
}
